export const dataHoidap = [
  {
    id: 1,
    img: "https://cdn.tgdd.vn/hoi-dap/1448087/Thumbnail/cuong-sao-noi-voi-loat-deal-samsung-galaxy-watch4-giam-thumb.jpg",
    title: "Cưỡng sao nổi với loạt DEAL Samsung Galaxy Watch4 giảm tới 3 triệu",
    chude: "Thiết bị thông minh",
  },
  {
    id: 1,
    img: "https://cdn.tgdd.vn/hoi-dap/1450300/Thumbnail/cach-go-so-dien-thoai-tren-facebook-sieu-nhanh-chong-ban-thumb-1.jpg",
    title: "Cách gỡ số điện thoại trên Facebook siêu nhanh chóng bạn nên thử",
    chude: "Thiết bị thông minh",
  },
];
export const dataHoidap2 = [
  {
    id: 1,
    img: "https://cdn.tgdd.vn/hoi-dap/1449961/Thumbnail/top-5-dong-ho-thong-minh-befit-duoi-1-trieu-ma-ban-nen-so_thumbnail.jpg",
    title: "TOP 5 đồng hồ thông minh BeFit dưới 1 triệu mà bạn nên sở hữu ngay",
    chude: "Đồng hồ - Mắt kính",
  },
  {
    id: 2,
    img: "https://cdn.tgdd.vn/hoi-dap/1449826/Thumbnail/top-5-dong-ho-thong-minh-duoi-1-trieu-ma-ban-nen-suu-tam-thumb02.jpg",
    title: "TOP 5 đồng hồ thông minh dưới 1 triệu mà bạn nên sưu tầm ngay",
    chude: "Thủ thuật văn phòng",
  },
  {
    id: 3,
    img: "https://cdn.tgdd.vn/hoi-dap/1449543/Thumbnail/tin-vui-loat-dong-ho-thong-minh-moi-ra-mat-tang-kem-qua-thumb.jpg",
    title:
      "TIN VUI: Loạt đồng hồ thông minh mới ra mắt tặng kèm quà tai nghe xịn",
    chude: "Thiết bị thông minh",
  },
  {
    id: 4,
    img: "https://cdn.tgdd.vn/hoi-dap/1449579/Thumbnail/dai-tiec-deal-hot-sam-ngay-dong-ho-thong-minh-uu-dai-qua-Thumb.jpg",
    title: "Đại tiệc deal hot sắm ngay đồng hồ thông minh ưu đãi quà tặng kèm",
    chude: "Thiết bị thông minh",
  },
  {
    id: 5,
    img: "https://cdn.tgdd.vn/hoi-dap/1436557/Thumbnail/top-dien-thoai-tot-nhat-tam-gia-4-trieu-ban-nen-mua-thumb-1.jpg",
    title:
      "TOP 7 điện thoại tốt nhất tầm giá 2 triệu chất lượng siêu tốt tại TGDĐ",
    chude: "Thiết bị thông minh",
  },
  {
    id: 6,
    img: "https://cdn.tgdd.vn/hoi-dap/1447857/Thumbnail/an-toan-tiet-kiem-camera-ngoai-troi-3mp-tp-link-chua-toi-1-tgdd-thumb.jpg",
    title:
      "AN TOÀN - TIẾT KIỆM: Camera Ngoài Trời 3MP TP-link chưa tới 1 triệu",
    chude: "Thiết bị thông minh",
  },
  {
    id: 7,
    img: "https://cdn.tgdd.vn/hoi-dap/1447627/Thumbnail/alo-sam-ngay-dong-ho-thong-minh-garmin-cuc-xin-giam-dong-thumb.jpg",
    title: "ALO: Sắm ngay đồng hồ thông minh Garmin cực xịn giảm đồng loạt 35%",
    chude: "Thiết bị thông minh",
  },

  {
    id: 1,
    img: "https://cdn.tgdd.vn/hoi-dap/1448087/Thumbnail/cuong-sao-noi-voi-loat-deal-samsung-galaxy-watch4-giam-thumb.jpg",
    title: "Cưỡng sao nổi với loạt DEAL Samsung Galaxy Watch4 giảm tới 3 triệu",
    chude: "Thiết bị thông minh",
  },
  {
    id: 1,
    img: "https://cdn.tgdd.vn/hoi-dap/1450300/Thumbnail/cach-go-so-dien-thoai-tren-facebook-sieu-nhanh-chong-ban-thumb-1.jpg",
    title: "Cách gỡ số điện thoại trên Facebook siêu nhanh chóng bạn nên thử",
    chude: "Thiết bị thông minh",
  },
];
